angular.module('pipPopover', ['pipPopover.Service']);

import './Popover';
import './PopoverService';

export * from './IPopoverService';